import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ILopChuNhiemActionTypes } from "../../action-types/lop-chu-nhiem/ILopChuNhiemActionTypes";
import { ILopChuNhiemPageState } from "../../page-state-model/lop-chu-nhiem/ILopChuNhiemPageState";

const initialState: ILopChuNhiemPageState = {
    status: ePageBaseStatus.is_not_initialization,
    lopChuNhiems: [],
    filter: {
        dm_truong_id: -1,
        nam_hoc: "",
        dm_he_id: 0,
        dm_khoi_id: 0
    }
}

export const lopChuNhiemReducer = (state: ILopChuNhiemPageState = initialState, action: ILopChuNhiemActionTypes): ILopChuNhiemPageState => {
    switch (action.type) {
        case "LOP_CHU_NHIEM_CHANGE_FILTER":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                filter: action.payload
            }
        case "LOP_CHU_NHIEM_SELECT_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "LOP_CHU_NHIEM_SELECT_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                lopChuNhiems: action.payload
            }
        case "LOP_CHU_NHIEM_SELECT_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }


        default:
            return state;
    }

}